import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  ToggleButton,
  ToggleButtonGroup,
  Button,
  Drawer,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useLocation, useNavigate } from "react-router-dom";

function Header() {
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const [currentStep, setCurrentStep] = useState<number>(
    parseInt(localStorage.getItem("currentStep") ?? "1", 10)
  );
  const navigate = useNavigate()
  // const ActiveTask = localStorage.getItem('ActiveTask')
  const [ActiveTask, setActiveTask] = useState<any>(localStorage.getItem("ActiveTask") || "");



 
  useEffect(() => {
    const interval = setInterval(() => {
      const newValue = localStorage.getItem("ActiveTask");
      if (newValue !== ActiveTask) {
        setActiveTask(newValue); 
      }
    }, 500);
  
    return () => clearInterval(interval);
  }, [ActiveTask]);
  
  const currentStepRef = useRef(currentStep);
  useEffect(() => {
    currentStepRef.current = currentStep; // Always keep the latest value
  }, [currentStep]);

  // Effect to update currentStep when it changes in localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      setCurrentStep(parseInt(localStorage.getItem("currentStep") ?? "1", 10));
    };

    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(() => {
      const storedStep = localStorage.getItem("currentStep");

      if (storedStep === null) {
        setCurrentStep(0);
      } else {
        const parsedStep = parseInt(storedStep, 10);
        setCurrentStep((prevStep) =>
          prevStep !== parsedStep ? parsedStep : prevStep
        );
      }
    }, 500);

    // **Detect Tab Visibility Change**
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setTimeout(() => {
          const storedStep = localStorage.getItem("currentStep");
          setCurrentStep(storedStep ? parseInt(storedStep, 10) : 0);
        }, 1000); // Delay ensures React updates the state properly
      } else {
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(interval);
    };
  }, []);
  
  // **Clear currentStep when navigating away from CreateOrEditScoreCard**
  useEffect(() => {
    // Check if the current path contains "createOrEditScoreCard"
    const isOnCreateOrEditScoreCard = location.pathname.includes(
      "createOrEditScoreCard"
    );
  // console.log("Ative Tsak", ActiveTask)
    if (!isOnCreateOrEditScoreCard) {
      localStorage.removeItem("currentStep");
      setCurrentStep(0); // Reset state as well
    }
  }, [location.pathname]); 

  return (
    <Box className="h-100" >
      <Box
        height="64px"
        sx={{backdropFilter:'blur(10px)'}}
        bgcolor={{xs:'#ADB7923A',lg:'transparent'}}
        borderBottom='1px solid black'
        className="w-100 px-4 align-items-center justify-content-between"
        display={{xs:ActiveTask == 'dashboard'?'flex':'none', lg:'flex'}}
      >
        {/* Left-aligned text */}
        <Typography variant="h5" fontWeight={600}>
          {ActiveTask == 1 || ActiveTask == 3
            ? "Shopper’s Experience"
            : ActiveTask == 2
              ? "Fill the Review Questions"
              : ActiveTask === 'faq'? "FAQ"
              :ActiveTask?.charAt(0)?.toUpperCase() + ActiveTask?.slice(1)?.replace(/([A-Z])/g, ' $1').trim()}
        </Typography>

        {/* Right-aligned user info */}
        <Box display={{xs:"none",lg:'flex'}} className="gap-2 align-items-center" sx={{cursor:'pointer'}} onClick={()=>{navigate('/dashboard/myprofile')}}>
          <Avatar
            src={userData.profilePicUrl}
            sx={{ height: "32px", width: "32px" }}
          />
          <Typography  variant="subtitle2">
            {userData.firstName}&nbsp;{userData.lastName}
          </Typography>
          <KeyboardArrowDownIcon className="text-white" />
        </Box>
      </Box>
    </Box>
  );
}

export default Header;
